import { css } from "@emotion/react";
import { theme } from "@/constants/theme";

export const imageStyles = css({
  width: "100%",
  objectFit: "cover",
  borderRadius: 8,
  [theme.breakpoints.down("md")]: {
    height: "auto",
  },
});
